import {
  CloseButton,
  Dialog as HeadlessDialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';
import Markdown from 'react-markdown';

import xIcon from '/icons/x.svg';

export function FrameworkDetailsDialog(props: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}) {
  const { title, content, isOpen, onClose } = props;

  return (
    <HeadlessDialog
      open={isOpen}
      as="div"
      className="relative z-[999] focus:outline-none"
      onClose={onClose}
    >
      <DialogBackdrop className="fixed inset-0 bg-black/30" />

      <div className="fixed inset-0 z-10 flex items-center justify-center p-4">
        <DialogPanel className="flex max-h-[90vh] w-full max-w-[600px] flex-col rounded-xl bg-white shadow-lg backdrop-blur-2xl">
          <div className="sticky top-0 z-10 flex items-center justify-between gap-4 rounded-t-xl border-b bg-white p-4">
            <DialogTitle className="flex-1 text-xl font-bold tracking-tight text-black">
              {title}
            </DialogTitle>

            <CloseButton onClick={onClose}>
              <img src={xIcon} alt="Close" />
            </CloseButton>
          </div>

          <div className="flex-1 overflow-y-auto rounded-b-xl p-4">
            <div className="rendered-markdown-content text-sm tracking-tight text-[#19222A]">
              <Markdown
                components={{
                  h1: ({ node, ...props }) => (
                    <h1 className="text-2xl font-bold" {...props} />
                  ),
                  h2: ({ node, ...props }) => (
                    <h2 className="text-xl font-bold" {...props} />
                  ),
                  h3: ({ node, ...props }) => (
                    <h3 className="text-lg font-bold" {...props} />
                  ),
                }}
              >
                {content}
              </Markdown>
            </div>
          </div>
        </DialogPanel>
      </div>
    </HeadlessDialog>
  );
}
